import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import PasswordStrength, {PasswordStrengthDto} from "./PasswordStrength"
import HttpClient from "../helpers/HttpClient"

class AuthService {
    httpClient: HttpClient<PasswordStrength,
        PasswordStrengthDto> = new HttpClient<PasswordStrength, PasswordStrengthDto>(PasswordStrength)

    async SendPasswordResetEmail(
        email: string
    ): Promise<boolean> {
        const res = await AppContext.getApiClient().post("/users/password-reset-links", {
            email: email
        })
        return res && res.status == 200
    }

    ResetPassword(userID: string, hash: string, password: string) {
        AppContext.getApiClient().put(`/users/${userID}/password-reset/${hash}`, {
            password: password
        })
    }

    async ValidateResetPasswordLink(
        userID: string,
        hash: string
    ): Promise<boolean> {
        const res = await AppContext.getApiClient().get(`/users/${userID}/password-reset/${hash}`)
        return res && res.status == 200
    }

    async VerifyAuthCode(code: string): Promise<boolean> {
        const res = await AppContext.getApiClient().post("/validate-verification-code", {
            code: code
        })
        return res.isValidVerificationCode
    }

    async SendAuthCodeEmail(): Promise<boolean> {
        const res = await AppContext.getApiClient().post("/send-verification-code", {
            email: AppContext.getUserLoggedIn().attributes.email,
            userName: AppContext.getUserLoggedIn().attributes.name,
        })
        return res.verificationEmailSent
    }

    async GetPasswordStrength(id: string): Promise<PasswordStrength> {
        const res = await this.httpClient.get(`/password/strength/${id}`)
        return res as PasswordStrength
    }


}


const instance = new AuthService()
export default instance


// WEBPACK FOOTER //
// ./src/state/auth/AuthService.ts